import { ErrorResponse, StockTypeDropDown, StockTypeStatus } from '@gtpl/shared-models/common-models';
import { OccupancyEnum, RackAckResponse, RackDto, RackModel, RackPositionIdRequest, RackPositionModel, RackPositionResponseModel, RackResponseModel, RackSuggestionResponseDto, ReserveRackResponse, RmOccupancyEnum, RmRackAckResponse, RmRackModel, RmRackPositionEnum, RmRackPositionIdRequestDto, RmRackPositionModel, RmRackPositionResponseModel, RmReserveRackRequest } from '@gtpl/shared-models/masters';
import { CommonResponse, RackLevelResponseDto, RackTypeResponseDto, WarehouseDashboard, WarehouseDashboardResponseModel, WarehouseResponseData } from '@gtpl/shared-models/warehouse-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Not, Repository } from 'typeorm';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { ZoneMaster } from '../zone-master/zone-master.entity';
import {appSettings} from './../../../../config';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { PackingMethodService, RackService, ZoneService } from '@gtpl/shared-services/masters';
import { LocationsRequest } from './dto/rm-locations.request';
import { FgStockStatusEnum, RackReserveRequest, RackSuggestionDto } from '@gtpl/shared-models/warehouse-management';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';


import { RmRackDTONew } from './dto/rm-rack.dto';
import { RmRackPosition } from './rm-rack-position.entity';
import { RmRack } from '../rm-racks/rm-racks.entity';
import { RmRacksService } from '../rm-racks/rm-racks.service';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { RmRackIdRequest } from './dto/rm-rack-id-request';
import { plantIdRequest } from './dto/plant-request';
import { RmRackRepository } from '../rm-racks/dto/rm-rack-repository';
import { RmRackPositionRepository } from './dto/rm-rack-position-repository';
import { RackStatusRequestDto } from './dto/rm-rack-status.req';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class RmRackPositionService {
    constructor(
        private logService:LogsService,
        @InjectRepository(RmRackPosition) private rmRackRepository: Repository<RmRackPosition>,
      ) { }
    
    /**
     * Service to create new rack
     * @param rackDto 
     * @returns 
     */
     async createRmRackPosition(rmRackDto: RmRackDTONew): Promise<RmRackAckResponse> {
        const rackResult = await this.validateRmRackExistsOrNot(rmRackDto.rmRackPositionCode);
        if(rackResult) {
            throw new ErrorResponse(10000, 'Rack already exists');
        } else {
            const rackEntity = new RmRackPosition();
            rackEntity.rmRackMasterInfo = new RmRack();
            rackEntity.rmRackMasterInfo.rmRackId = rmRackDto.rmRackMasterId;
            rackEntity.rmRackCode = rmRackDto.rmRackPositionCode;
            rackEntity.rmRackPosition = rmRackDto.rmRackPosition;
            rackEntity.rmRackLevel = rmRackDto.rmRackLevel;
            // rackEntity.rmRackColumn = Number(rmRackDto.rmRackPositionCode.split(/([0-9]+)/)[1]);
            rackEntity.rmRackColumn = rmRackDto.rmRackColumn;
            rackEntity.rmRackBoundaries = rmRackDto.rmRackBoundaries;
            rackEntity.rmRackPositionType = rmRackDto.rmRackPositionType;
            rackEntity.assocRfId = rmRackDto.assocRfId;
            rackEntity.plantId = rmRackDto.plantId;
            rackEntity.createdUser = rmRackDto.createdUser;
            rackEntity.zoneId = rmRackDto.zoneId;
            if(rmRackDto.occupancy) {
                rackEntity.occupancy = rmRackDto.occupancy;
            }           
            const manager = getManager()
            const query = `SELECT rm_rack_id AS rmRackMasterId , zone_id AS zoneId , MAX(rm_rack_position_code) as rmRackReserveCode , MAX(rm_rack_reserve_code) AS rmRackPositionCode FROM ` + appSettings.masters_db + `.rm_rack_position WHERE rm_rack_id = ` + rmRackDto.rmRackMasterId + ` AND zone_id = ` + rmRackDto.zoneId + ` ` 
            const data = await manager.query(query)
            rackEntity.rmRackReserveCode = Number(data[0].rmRackReserveCode) + 1
            rackEntity.rmRackPositionCode = Number(data[0].rmRackPositionCode) + 1
            const rackResponse = await this.rmRackRepository.save(rackEntity);
            console.log('------response------',rackResponse)
            if (rackResponse) {
                const response = new RmRackAckResponse(true, 10000, 'Rack Details Created Successfully');
                // const name=isUpdate?'updated':'created'
                const newLogDto = new LogsDto(1,'created', 'RmRackPosition', rackResponse.rmRackPositionId, true, '',rackResponse.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }
        }
    }

    /**
     * validate if a rack is existed or not
     * @param rmRackCode
     * @returns boolean true/false
     */
    async validateRmRackExistsOrNot(rmRackCode: string): Promise<boolean> {
        const rackResponse = await this.rmRackRepository.findOne({
            where: { rmRackCode: rmRackCode },
        });
        if(rackResponse) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Service to update a rack details
     * @param rmRackDto 
     * @returns 
     */
    async updateRmRackPosition(rmRackDto: RmRackDTONew): Promise<RmRackAckResponse> {
        const rackEntity = await this.rmRackRepository.findOne({
            where: { rmRackCode: rmRackDto.rmRackPositionCode },
        });
        if(!rackEntity) {
            throw new ErrorResponse(10000, 'Rack details not found');
        } else {
            rackEntity.rmRackMasterInfo = new RmRack();
            rackEntity.rmRackMasterInfo.rmRackId = rmRackDto.rmRackMasterId;
            rackEntity.rmRackCode = rmRackDto.rmRackPositionCode;
            rackEntity.rmRackPosition = rmRackDto.rmRackPosition;
            rackEntity.rmRackLevel = rmRackDto.rmRackLevel;
            rackEntity.rmRackColumn = Number(rmRackDto.rmRackPositionCode.split(/([0-9]+)/)[1]);
            rackEntity.rmRackBoundaries = rmRackDto.rmRackBoundaries;
            rackEntity.rmRackPositionType = rmRackDto.rmRackPositionType;
            rackEntity.assocRfId = rmRackDto.assocRfId;
            rackEntity.plantId = rmRackDto.plantId;
            rackEntity.updatedUser = rmRackDto.updatedUser;
            if(rmRackDto.occupancy) {
                rackEntity.occupancy = rmRackDto.occupancy;
            }    
            const rackResponse = await this.rmRackRepository.save(rackEntity);            
            if (rackResponse) {
                const response = new RmRackAckResponse(true, 10000, 'Rack Details Updated Successfully');
                const newLogDto = new LogsDto(1,'updated', 'RmRackPosition', rackResponse.rmRackPositionId, true, '',rackResponse.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response
            }
        }
    }

    /**
     * Service to get all the racks
     * @returns 
     */
    async getAllRmRacksPositions(): Promise<RmRackAckResponse> {
        const racksResponse = await this.rmRackRepository.find({
            relations:["rmRackMasterInfo"],
            order:{rmRackId: "ASC"},
        });

        const rackDetails: RmRackModel[] = [];
        if (racksResponse.length === 0) {
            throw new ErrorResponse(9999, 'Rack details not found');
        }
        for(const rack of racksResponse) {
            const rackModel = new RmRackModel(rack.rmRackPositionId,rack.rmRackCode,rack.plantId,rack.assocRfId,rack.rmRackPosition,rack.rmRackLevel,rack.rmRackBoundaries,rack.occupancy,rack.createdAt,rack.updatedAt, rack.isActive,rack.versionFlag,rack.rmRackMasterInfo.rmRackId,rack.rmRackMasterInfo.rmRackName,rack.rmRackMasterInfo.rmRackCode,rack.rmRackPositionType);
            rackDetails.push(rackModel);
        }
        const response = new RmRackAckResponse(true, 10000, 'Rack Details Retrived Successfully', rackDetails);       
        const newLogDto = new LogsDto(1,'view', 'RmRackPosition', 0, true, '','')
        let res = await this.logService.createLog(newLogDto);
        console.log(res);
        return response
    }

    /**
     * Service to get all the racks by plant id
     * @param plantIdReq
     * @returns 
     */
     async getAllRmRacksByPlantId(plantIdReq: PlantIdRequest): Promise<RmRackAckResponse> {
        const racksResponse = await this.rmRackRepository.find({
            relations:["rmRackMasterInfo"],
            where: {plantId: plantIdReq.plantId},
            order:{rmRackId: "ASC"},
        });

        const rackDetails: RmRackModel[] = [];
        if (racksResponse.length === 0) {
            throw new ErrorResponse(9999, 'Rack details not found');
        }
        for(const rack of racksResponse) {
             const rackModel = new RmRackModel(rack.rmRackPositionId,rack.rmRackCode,rack.plantId,rack.assocRfId,rack.rmRackPosition,rack.rmRackLevel,rack.rmRackBoundaries,rack.occupancy,rack.createdAt,rack.updatedAt, rack.isActive,rack.versionFlag,rack.rmRackMasterInfo.rmRackId,rack.rmRackMasterInfo.rmRackName,rack.rmRackMasterInfo.rmRackCode);
            rackDetails.push(rackModel);
        }
        return new RmRackAckResponse(true, 10000, 'Rack Details Retrived Successfully', rackDetails);       
    }


    /**
     * 
     * @param rackReq 
     * @returns 
     */
    async activateOrDeactivateRmRack(rackReq: any): Promise<RmRackAckResponse> {
        const rackExists = await this.rmRackRepository.findOne({
            where: { rackPositionId: rackReq.rackId },
        });
        if (rackExists) {
            if (rackReq.versionFlag !== rackExists.versionFlag) {
                throw new ErrorResponse(10113, 'Someone updated the current Rack information.Refresh and try again');
            } else {                    
                const rackStatus =  await this.rmRackRepository.update(
                    { rmRackPositionId: rackReq.rmRackId },
                    { isActive: rackReq.isActive,updatedUser: rackReq.updatedUser });
                
                if (rackExists.isActive) {
                    if (rackStatus.affected) {
                        const rackResponse = new RmRackAckResponse(true, 10115, 'Rack is de-activated successfully');
                        return rackResponse;
                    } else {
                        throw new ErrorResponse(10111, 'Rack is already deactivated');
                    }
                } else {
                    if (rackStatus.affected) {
                        const rackResponse = new RmRackAckResponse(true, 10114, 'Rack is activated successfully');
                        return rackResponse;
                    } else {
                        throw new ErrorResponse(10112, 'Rack is already  activated');
                    }
                }
            }
        } else {
            throw new ErrorResponse(99998, 'No Records Found');
        }
    }
    async getRmRacksForRackId(rackPostionRequest: RmRackIdRequest): Promise<RmRackPositionResponseModel> {
        const data : RmRackPositionModel[] = []
        const racksResponse = await this.rmRackRepository.find({
            relations:["rmRackMasterInfo"],
            where: {rmRackId: rackPostionRequest.rmRackId, occupancy: OccupancyEnum.NOT_OCCUPIED},
            order:{rmRackPositionType: "DESC"},
            
        });
        if(racksResponse.length>0){
            racksResponse.forEach(rack => {
                const rackModel = new RmRackPositionModel(rack.rmRackCode,rack.plantId,rack.assocRfId,rack.rmRackPosition,rack.rmRackLevel,rack.rmRackBoundaries,rack.occupancy,rack.rmRackId,rack.isActive,rack.rmRackPositionId,rack.rmRackMasterInfo.rmRackName,rack.rmRackMasterInfo.rmRackCode);
                data.push(rackModel);
            });
            return new RmRackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);     
        }
        else{
            return new RmRackPositionResponseModel(false, 10000, 'Rack Details not found');     
        }
          
    }

    async getWarehouseRackDetails(req: RackReserveRequest): Promise<WarehouseDashboardResponseModel> {
        const manager = getManager();
        console.log("hii")
        console.log(req)
        try {
            const colCountQuery = `select MAX(rp.rm_rack_column) AS colCount from ` + appSettings.masters_db + `.rm_rack r left join ` + appSettings.masters_db + `.rm_rack_position rp ON rp.rm_rack_id=r.rm_rack_id where r.rm_rack_id = ` + req.rackId;
            // const colCountQuery = `select MAX(rack_column) AS colCount from ` + appSettings.masters_db + `.rack_position where zone_id=` + req.zoneId + ` and rack_id=` + req.rackId + ` and plant_id= ` + req.plantId;
            const colCount = await manager.query(colCountQuery);
            const racksQuery = `select rm_rack_id,rm_rack_code,rm_rack_type,plant_id AS plantId from ` + appSettings.masters_db + `.rm_rack where zone_id=` + req.zoneId + ` and rm_rack_id = ` + req.rackId + ` limit 1`;
            const racksData = await manager.query(racksQuery);
            console.log(racksData);
            console.log(racksData[0].rm_rack_id);

            let levelsQuery;
            if (req.plantId != 2) {
                levelsQuery = `select level_id,level_code from ` + appSettings.masters_db + `.rm_level where is_active= true order by level_id desc`;
            }
            else {
                levelsQuery = `select level_id,level_code from ` + appSettings.masters_db + `.rm_level where is_active= true order by level_id asc`;
            }

            const levelsData = await manager.query(levelsQuery);
            console.log(levelsData);
            const data = [];
            const racksInfo: WarehouseDashboard[] = [];
            if (racksData.length > 0) {
                const rackData = new WarehouseDashboard();
                rackData.rackId = racksData[0].rm_rack_id;
                rackData.rackName = racksData[0].rm_rack_code;
                rackData.colCount = colCount[0].colCount;
                rackData.rackType = racksData[0].rm_rack_type;
                rackData.plantId = racksData[0].plantId;
                let rackPositionsData: RackLevelResponseDto[] = [];
                for (const level of levelsData) {
                    let warehouseResponseFront: ReserveRackResponse[] = [];
                    let warehouseResponseRear: ReserveRackResponse[] = [];
                    let rackType: RackTypeResponseDto[] = [];
                    console.log(racksData);
                    let rackPositionsFrontQuery;
                    // if (req.plantId != 2) {
                        rackPositionsFrontQuery = `SELECT mb.brand_name AS masterBrandName,isc.item_sub_category As itemSubCategoryName,z.rm_zone_id as zoneId,z.rm_zone_code AS zoneCode,r.rm_rack_id as rackId,r.rm_rack_position_id AS rackPositionId,r.rm_rack_code AS rackCode,r.occupancy AS occupancy,b.brand_name as brandName,r.plant_id AS unitId, UPPER(r.rm_rack_position_type) AS rackPositionType, r.is_reserved AS isReserved, r.rm_rack_level AS rackLevel, r.rm_rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rm_rack_position r LEFT JOIN `+appSettings.masters_db+ `.master_brands mb on mb.master_brand_id = r.brand_id LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc on isc.item_sub_category_id = r.item_sub_category_id LEFT JOIN ` + appSettings.masters_db + `.rm_level l ON l.level_id= r.rm_rack_level LEFT JOIN ` + appSettings.masters_db + `.rm_rack rs ON rs.rm_rack_id=r.rm_rack_id LEFT JOIN ` + appSettings.masters_db + `.rm_zones z ON z.rm_zone_id=rs.allocated_zone_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=r.brand_id left join `+appSettings.masters_db+`.item_sub_categories it on it.item_sub_category_id = r.item_sub_category_id where r.rm_rack_id=` + racksData[0].rm_rack_id + ` and r.plant_id=`+req.plantId+` and r.rm_rack_position_type='front' and r.rm_rack_level = ` + level.level_id + ` group by r.rm_rack_position_id order by r.rm_rack_column desc,r.rm_rack_level asc`;
                    // }
                    // else {
                    //     rackPositionsFrontQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,sid.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sk.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, so.po_number AS poNo, r.is_reserved AS isReserved, sc.variant_code AS variantCode, SUM(st.total_cartons) AS totalCartons, s.pallet_capacity AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rm_rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.location= r.rack_position_id AND s.stock_id = (SELECT MAX(stock_id) FROM stock s WHERE s.location = r.rack_position_id and s.status = "StockIn") LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.rack rs ON rs.rack_id=r.rack_id LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=rs.allocated_zone_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=r.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = si.varient_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id where r.rack_id=` + racksData[0].rm_rack_id + ` and r.rack_position_type='front' and r.rack_level = ` + level.level_id + ` group by r.rack_position_id order by r.rack_column asc,r.rack_level asc, s.stock_id desc`;
                    // }


                    warehouseResponseFront = await manager.query(rackPositionsFrontQuery);

                    let rackPositionsRearQuery
                    // if (req.plantId != 2) {
                        rackPositionsRearQuery = `SELECT mb.brand_name AS masterBrandName,isc.item_sub_category As itemSubCategoryName,z.rm_zone_id as zoneId,z.rm_zone_code AS zoneCode,r.rm_rack_id as rackId,r.rm_rack_position_id AS rackPositionId,r.rm_rack_code AS rackCode,r.occupancy AS occupancy,b.brand_name as brandName,r.plant_id AS unitId, UPPER(r.rm_rack_position_type) AS rackPositionType, r.is_reserved AS isReserved, r.rm_rack_level AS rackLevel, r.rm_rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rm_rack_position r LEFT JOIN `+appSettings.masters_db+ `.master_brands mb on mb.master_brand_id = r.brand_id LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc on isc.item_sub_category_id = r.item_sub_category_id LEFT JOIN ` + appSettings.masters_db + `.rm_level l ON l.level_id= r.rm_rack_level LEFT JOIN ` + appSettings.masters_db + `.rm_rack rs ON rs.rm_rack_id=r.rm_rack_id LEFT JOIN ` + appSettings.masters_db + `.rm_zones z ON z.rm_zone_id=rs.allocated_zone_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=r.brand_id left join `+appSettings.masters_db+`.item_sub_categories it on it.item_sub_category_id = r.item_sub_category_id where r.rm_rack_id=` + racksData[0].rm_rack_id + ` and r.plant_id=`+req.plantId+` and r.rm_rack_position_type='rear' and r.rm_rack_level = ` + level.level_id + ` group by r.rm_rack_position_id order by r.rm_rack_column desc,r.rm_rack_level asc`;
                    // }
                    // else {
                    //     rackPositionsRearQuery = `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,sid.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sk.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId, UPPER(r.rack_position_type) AS rackPositionType, so.po_number AS poNo, r.is_reserved AS isReserved, sc.variant_code AS variantCode, SUM(st.total_cartons) AS totalCartons, s.pallet_capacity AS palletCapacity, r.rack_level AS rackLevel, r.rack_column AS rackColumn,r.is_active AS isActive FROM ` + appSettings.masters_db + `.rm_rack_position r LEFT JOIN ` + appSettings.warehouse_db + `.stock s ON s.location= r.rack_position_id AND s.stock_id = (SELECT MAX(stock_id) FROM stock s WHERE s.location = r.rack_position_id and s.status = "StockIn") LEFT JOIN ` + appSettings.warehouse_db + `.stock st ON st.location= r.rack_position_id LEFT JOIN ` + appSettings.masters_db + `.level l ON l.level_id= r.rack_level LEFT JOIN ` + appSettings.masters_db + `.rack rs ON rs.rack_id=r.rack_id LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id=rs.allocated_zone_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=r.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=st.sale_order_item_id LEFT JOIN  ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = si.varient_id LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id=s.product_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=r.varient_id where r.rack_id=` + racksData[0].rm_rack_id + ` and r.rack_position_type='rear' and r.rack_level = ` + level.level_id + ` group by r.rack_position_id order by r.rack_column asc,r.rack_level asc,s.stock_id desc`;
                    // }


                    warehouseResponseRear = await manager.query(rackPositionsRearQuery);

                    let rearRacksData = new RackTypeResponseDto("REAR", warehouseResponseRear)
                    let frontRacksData = new RackTypeResponseDto("FRONT", warehouseResponseFront)
                    rackType.push(rearRacksData)
                    rackType.push(frontRacksData)
                    // console.log(rearRacksData)
                    console.log(rackType)
                    let rearData = new RackLevelResponseDto(level.level_id, rackType)
                    // let frontData = new RackLevelResponseDto(level.level_id,frontRacksData)
                    console.log(rearData)
                    // console.log(frontData)
                    rackPositionsData.push(rearData);
                    // rackPositionsData.push(frontData);
                }
                console.log(rackPositionsData);
                rackData.rackPositions = rackPositionsData;
                racksInfo.push(rackData);
                // for(const [index,rackItem] of racksInfo){

                // }
                racksInfo[0].expandStatus = true

                console.log(racksInfo);
                const data = new WarehouseDashboardResponseModel(true, 1001, 'data retrieved successfully', racksInfo);
                const newLogDto = new LogsDto(1,'view Rack Details', 'RmRackPosition', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return data
            } else {
                return new WarehouseDashboardResponseModel(false, 99999, 'Racks Data not found');
            }
            // await new Promise(resolve => setTimeout(resolve, 200));                   
            // warehouseResponse = await manager.find(WarehouseView,{unitId:req.plantId,zoneId:req.zoneId});

        } catch (error) {
            console.log(error)
            return error;
        }
    }
    async getReserveRackPosition(rackPositionIdRequest: RmReserveRackRequest): Promise<CommonResponse> {
        try {
            let itemSubCategoryId;
            let brandId
            let plantId
            let reservedDate

            // let minGrade;
            // let maxGrade;
            if (rackPositionIdRequest.isReserved) {
                itemSubCategoryId = rackPositionIdRequest.itemSubCategoryId;
                brandId = rackPositionIdRequest.brandId;
                plantId = rackPositionIdRequest.plantId;
                reservedDate = new Date();
                // maxGrade = rackPositionIdRequest.maxGrade;
            }
            else {
                itemSubCategoryId = null;
                brandId = null;
                plantId = null;
                reservedDate =null;
                // maxGrade = null;
            }
            const getRackDetails = await this.rmRackRepository.findOne({
                where: { rmRackPositionId: rackPositionIdRequest.rackPositionId}
            });
            console.log(getRackDetails);
            if (getRackDetails != undefined) {
                let status = rackPositionIdRequest.isReserved ? RmOccupancyEnum.RESERVED : RmOccupancyEnum.NOT_OCCUPIED
                const rackStatus = await this.rmRackRepository.update({ rmRackPositionId: rackPositionIdRequest.rackPositionId}, { isReserved: rackPositionIdRequest.isReserved, updatedUser: rackPositionIdRequest.updatedUser, itemSubCategoryId: itemSubCategoryId, brandId: brandId, reservedDate: reservedDate,occupancy: status });
                console.log(rackStatus)
                if (rackStatus.affected > 0) {
                    console.log(rackPositionIdRequest.isReserved);
                    return new CommonResponse(true, 1001, rackPositionIdRequest.isReserved ? "Rack Reserved Successfully. " : "Rack Unreserved successfully. ", getRackDetails);
                }
                else {
                    return new CommonResponse(false, 1010, "Something went wrong. ", getRackDetails);
                }
            }
            return new CommonResponse(false, 1010, "Rack Position not found. ", getRackDetails);
        }
        catch (error) {
            return error
        }
    }

    async getRmRackPostionsForLocationMapping(req:plantIdRequest):Promise<CommonResponse>{
        try{
        const manager = getManager();
        let reservedlocationsDataQry
        let unreservedlocationsDataQry
        if(req.plantId == 2 || req.plantId == 3){
            reservedlocationsDataQry =  `select rm_rack_position_id as rackPositionId,rm_rack_code as location,IF(occupancy = 'Partially Occupied','#fb880e',(IF(occupancy = 'Not Occupied','#72a524','#200df0b8'))) AS color  from rm_rack_position where rm_rack_position_id > 0 and ((brand_id=`+req.brandId+` and is_reserved = 1 AND  plant_id = `+req.plantId+` AND occupancy ='`+RmOccupancyEnum.RESERVED+`') OR ((brand_id=`+req.brandId+` and plant_id = `+req.plantId+` AND occupancy ='`+RmOccupancyEnum.PARTIALLY_OCCUPIED+`') OR (plant_id = `+req.plantId+` and is_reserved = 0 and occupancy = 'Not Occupied')))`
        }else{
            reservedlocationsDataQry = `select rm_rack_position_id as rackPositionId,rm_rack_code as location,IF(occupancy = 'Partially Occupied','yellow',(IF(occupancy = 'Not Occupied','green','blue'))) AS color  from rm_rack_position where plant_id =`+req.plantId+` and occupancy in('`+RmOccupancyEnum.RESERVED+`','`+RmOccupancyEnum.PARTIALLY_OCCUPIED+`') and is_reserved = 1 and brand_id = `+req.brandId
        }
            const reservedlocationsData = await manager.query(reservedlocationsDataQry);
            if(reservedlocationsData.length > 0){
                return new CommonResponse(true,5555,'data retrived',reservedlocationsData)
            }else{
                // if(req.plantId == 2 || req.plantId == 3){
                //     unreservedlocationsDataQry =  `select rm_rack_position_id as rackPositionId,rm_rack_code as location from rm_rack_position where plant_id = 0 and is_reserved = 0 and occupancy = 'Not Occupied'`
                // }else{
                    unreservedlocationsDataQry = `select  rm_rack_position_id as rackPositionId,rm_rack_code as location from rm_rack_position where plant_id =`+req.plantId+` and is_reserved = 0 and occupancy = 'Not Occupied'`
                // }
                const unreservedlocationsData = await manager.query(unreservedlocationsDataQry);
                if(unreservedlocationsData.length > 0){
                    return new CommonResponse(true,5555,'Un Reserved locations data retrived',unreservedlocationsData)
                }else{
                    return new CommonResponse(false,444,'No data found')
                }
            }
        }catch(err){
            return new CommonResponse(false,4444,err)
        }
    }

    async getReverseLocationAvailability(req:RmRackPositionIdRequestDto):Promise<CommonResponse>{
        const manager = new GenericTransactionManager();
        try{
            const getRackDetails = await this.rmRackRepository.findOne({where:{rmRackPositionId: req.rmRackPositionId}});
            console.log(getRackDetails);
            if(getRackDetails.rmRackPositionId  > 0){
                await manager.startTransaction();
                let updateRackPosition = await manager.getCustomRepository(RmRackPositionRepository).update({ rmRackPositionId:req.rmRackPositionId }, { isReserved:false,brandId:null,itemSubCategoryId:null,saleOrderId:null,saleOrderItemId:null,occupancy: () => `"${OccupancyEnum.NOT_OCCUPIED}"` });
                console.log(updateRackPosition)
                if (updateRackPosition.affected) {
                    manager.completeTransaction();
                    return new CommonResponse(true,1001,"Location updated successfully. ");
                }
                else{
                    await manager.releaseTransaction();
                    return new CommonResponse(false,1010,"Something went wrong. ");
                }
            }
            else{
                await manager.releaseTransaction();
                return new CommonResponse(false,1010,"Location not found. ");
            }
        }catch(err){
            await manager.releaseTransaction();
            console.log(err);
            return new CommonResponse(false,1010,err);
        }
    }

    async updateRmLocationStatus(req:RackStatusRequestDto):Promise<CommonResponse>{
        const manager = getManager();
        try{
            const updateStatusQry = `update `+appSettings.masters_db+`.rm_rack_position set occupancy = '${req.status}',brand_id = ${req.brandId},item_sub_category_id = ${req.itemSubCategoryId} where rm_rack_position_id = ${req.rmRackPositionId}`;
            const updateStatus = manager.query(updateStatusQry)
            if(updateStatus){
                return new CommonResponse(true,1010,"Location Status Updated. ");
            }else{
                await manager.release()
                return new CommonResponse(false,1010,"Something went wrong.");
            }

        }catch(err){
            await manager.release()
            return new CommonResponse(false,1010,err);
        }
    }

    async getRmZones(req:plantIdRequest):Promise<CommonResponse>{
        const manager = getManager();
        console.log(req.plantId,)
        let query
        if(req.plantId == 2 || req.plantId == 3){
            query = `SELECT rm_zone_id as zoneId , rm_zone_name as rmZoneName FROM ` + appSettings.masters_db + `.rm_zones where rm_zone_id > 0 and plant_id in(2,3)`
        }else{
            query = `SELECT rm_zone_id as zoneId , rm_zone_name as rmZoneName FROM ` + appSettings.masters_db + `.rm_zones where rm_zone_id > 0 and plant_id =`+req.plantId 
        }
     
        const data = await manager.query(query)
        if(data.length > 0 ){
            return new CommonResponse(true,1010,"Zones retrived succesfully",data);
        }else{
            return new CommonResponse(false,1010,"Zones not found");
        }
    }

    async getLocationsForStockEntryScreen():Promise<CommonResponse>{
        const manager = getManager();
        const query = `select rm_rack_position_id as rackPositionId,rm_rack_code as location  from rm_rack_position where  plant_id != 1`
        const data = await manager.query(query)
        if(data.length > 0 ){
            return new CommonResponse(true,1010,"Data retreived sucessfulyy",data);
        }else{
            return new CommonResponse(false,1010,"Data not found");
        }
    }

    async updateLocationData(rmRackPositionId:number):Promise<CommonResponse>{
          const dto = new RmRackDTONew();
          dto.brandId = null;
          dto.isReserved = false;
          dto.itemSubCategoryId = null;
          dto.occupancy = RmOccupancyEnum.NOT_OCCUPIED;
          await this.rmRackRepository.update({rmRackPositionId : rmRackPositionId},{brandId :dto.brandId , isReserved:dto.isReserved,itemSubCategoryId:dto.itemSubCategoryId , occupancy :dto.occupancy})
          const response = new CommonResponse(true,11100,'updated succesfully',)
        return response
    }

}
